<div class="w-full flex flex-col gap-2">
    <label *ngIf="label" class="typography-body-s-regular">
        {{ label }}
    </label>
    <div [ngClass]="{'select-container': true, 'select-container__ghost': ghost}">
        <div class="px-4"
            [ngClass]="{
            'select-main': true,
            'select-main__ghost': ghost,
            'select-main__small': small,
            'select-main__error': required && !isOpen && dirty && !selectedValue,
            'select-main__disabled': disabled
        }"
        (click)="toggleSelect()">
            <p class="typography-body-m-regular" [ngClass]="{'text-text-tertiary': !selectedValue?.label}">
                {{ selectedValue && selectedValue.label ? (selectedValue.label | translate) : placeholder }}
            </p>
            
            <div class="select-main__actions">
                <div *ngIf="isClearable && selectedValue"
                     class="select-main__clear"
                     (click)="onValueClear($event)">
                    <img src="assets/icons/close.svg" alt="Clear">
                </div>
                <img src="assets/icons/chevron-down.svg"
                     [class.rotate-180]="isOpen"
                     alt="Toggle">
            </div>
        </div>

        <app-select-box *ngIf="isOpen"
            [values]="filteredOptions"
            [customHeight]="customBoxHeight"
            [(isOpen)]="isOpen"
            (valueSelected)="onValueSelect($event)">
            <div *ngIf="searchable" class="select-search">
                <input type="text"
                       class="select-search__input"
                       [value]="searchTerm"
                       (input)="onSearch($event)"
                       (click)="onSearchClick($event)"
                       [placeholder]="'global.search_input_placeholder' | translate"
                       autocomplete="off">
            </div>
        </app-select-box>
    </div>
</div>
